"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpIcon = void 0;
const react_1 = __importDefault(require("react"));
const components_1 = require("@veeam/components");
const SvgIcon_1 = require("./SvgIcon");
const UpIcon = ({ disabled }) => (react_1.default.createElement(components_1.Icon, { disabled: disabled, src: react_1.default.createElement(SvgIcon_1.SvgIcon, { disabled: disabled },
        react_1.default.createElement("path", { fill: "#4997C7", d: "M15 7.5L9.6 2.1 7.5 0 5.4 2.1 0 7.5v4.2l6-6V16h3V5.7l6 6z" })) }));
exports.UpIcon = UpIcon;
//# sourceMappingURL=UpIcon.js.map